var socketCutOutsMixin = {
    data: function () {
        return {
            product: {
                socketCutOuts: {
                    noOfCutOuts: 0,
                    additionalInfo: ''
                },
                socketCutOutUploads: ''
            }
        }
    },
    methods: {
        /**
         * Determines whether the dropzone exists and if there are any images there to upload
         */
        hasSocketCutOutsToUpload: function () {
            if (document.querySelector("#vueProduct #file-uploads")) {
                const vm = this;

                const socketUploads = Dropzone.forElement('#' + vm.$el.id + " #file-uploads");

                if (socketUploads.files.length === 0)
                    return false;

                return true;
            };
        },
        /**
         * Uploads socket cut out files
         */
        uploadSocketCutOuts: function () {
            const vm = this;
            const socketUploads = Dropzone.forElement('#' + vm.$el.id + " #file-uploads");

            socketUploads.processQueue();

            socketUploads.on("successmultiple", function (file, response) {
                vm.product.socketCutOutUploads = response;
                console.log('uploaded')
                vm.addConfiguredProduct();
            });
            socketUploads.on("error", function (file, response) {
                    return false;
            });

            return true;
        }
    },
}